/**
 * Menu
 */
(() => {
  const menu = document.querySelector('header .header-nav-new .menu');
  if (!menu) return;

  const dropdown = menu.querySelector('.cd-dropdown');
  let activeMenu;

  const dropdownTrigger = menu.querySelector('.cd-dropdown-trigger');
  if (dropdownTrigger) {
    dropdownTrigger.addEventListener('click', () => {
      setTimeout(() => {
        // eslint-disable-next-line no-undef
        resizeVerticalMenuDesktop();
      });
    });
  }

  dropdown.querySelectorAll('ul.cd-dropdown-content > li')
    .forEach((item) => {
      const firstLevelAnchor = item.querySelector('a');
      if (!firstLevelAnchor) return;

      // First level anchor click
      firstLevelAnchor.addEventListener('click', (e) => {
        e.preventDefault();

        if (activeMenu && activeMenu !== item) {
          activeMenu.classList.remove('active');
        }

        activeMenu = item;
        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          dropdown.classList.add('active');
        } else {
          dropdown.classList.remove('active');
        }
      });

      const secondLevel = item.querySelector(':scope > ul.cd-secondary-dropdown');
      if (!secondLevel) return;

      // Creating the first level anchor image-wrapper
      const firstLevelImageWrapper = document.createElement('div');
      firstLevelImageWrapper.classList.add('image-wrapper');
      firstLevelAnchor.appendChild(firstLevelImageWrapper);

      // Moving the menu-image inside the first level anchor image-wrapper
      const menuImage = secondLevel.querySelector('.menu-image img');
      if (menuImage) {
        firstLevelImageWrapper.appendChild(menuImage);
      }

      // Creating the first level anchor content-wrapper
      const firstLevelContentWrapper = document.createElement('span');
      firstLevelContentWrapper.classList.add('text');
      firstLevelAnchor.appendChild(firstLevelContentWrapper);

      // Moving the first level anchor content inside the first level anchor content-wrapper
      const firstLevelAnchorContent = firstLevelAnchor.innerText;
      firstLevelContentWrapper.textContent = firstLevelAnchorContent;

      secondLevel.querySelectorAll(':scope > li')
        .forEach((submenu) => {
          const secondLevelAnchor = submenu.querySelector('a');
          if (!secondLevelAnchor) return;

          // Creating the second level anchor image-wrapper
          const secondLevelImageWrapper = document.createElement('div');
          secondLevelImageWrapper.classList.add('image-wrapper');
          secondLevelAnchor.appendChild(secondLevelImageWrapper);

          // Moving the sub-category-image inside the second level anchor image-wrapper
          const subCategoryImage = submenu.querySelector('.sub-category-image img');
          if (subCategoryImage) {
            secondLevelImageWrapper.appendChild(subCategoryImage);
          }

          // Creating the second level anchor content-wrapper
          const secondLevelContentWrapper = document.createElement('span');
          secondLevelContentWrapper.classList.add('text');
          secondLevelAnchor.appendChild(secondLevelContentWrapper);

          // Moving the second level anchor content inside the second level anchor content-wrapper
          const secondLevelAnchorContent = secondLevelAnchor.innerText;
          secondLevelContentWrapper.textContent = secondLevelAnchorContent;
        });
    });
})();

/** Menu Mobile */
(() => {
  const menuMobile = document.querySelector('#mobileVueNav');
  if (!menuMobile) return;

  function handleMutation() {
    const goBack = menuMobile.querySelector('.go-back-mobile');
    if (goBack && !goBack.classList.contains('hide')) {
      menuMobile.dataset.menuMobileObserved = 'true';
      const anchors = menuMobile.querySelectorAll('.has-children a');

      anchors.forEach((anchor) => {
        anchor.classList.add('no-children');
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          const href = anchor.getAttribute('href');
          if (!href) return;

          window.location.assign(href);
          const closeMenu = document.querySelector('.header-mobile .cd-close');
          if (closeMenu) {
            closeMenu.click();
          }
        });
      });
    }
  }

  const mutationObserver = new MutationObserver(() => {
    handleMutation();
  });

  mutationObserver.observe(menuMobile, {
    childList: true,
    subtree: true,
  });

  handleMutation();
})();

/**
 * Footer
 */
(() => {
  const footer = document.querySelector('footer.footer');
  if (!footer) return;

  // Move Payment logos to payments-foot-wrapper
  const paymentsFooter = footer.querySelector('.payments-foot-wrapper');
  const paymentsLogos = footer.querySelector('.paymentmethodslogos_container');
  if (paymentsFooter && paymentsLogos) {
    paymentsFooter.appendChild(paymentsLogos);
  }

  // Move the social icons to the left of the footer copyright
  const footerSocial = footer.querySelector('.dealerdetails_container .nSocial');
  const footerBot = footer.querySelector('.footer-bot .copyright_container > div');

  if (footerSocial && footerBot) {
    footerBot.prepend(footerSocial);
  }
})();
